import { render, staticRenderFns } from "./TurnoList.vue?vue&type=template&id=ed8643fe&scoped=true"
import script from "./TurnoList.vue?vue&type=script&lang=js"
export * from "./TurnoList.vue?vue&type=script&lang=js"
import style0 from "./TurnoList.vue?vue&type=style&index=0&id=ed8643fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8643fe",
  null
  
)

export default component.exports